var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row margin-top" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-8 offset-2 background text-center" }, [
        _c(
          "form",
          {
            attrs: { autocomplete: "no" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.sendCode($event)
              },
              keydown: function($event) {
                _vm.clearError($event)
              }
            }
          },
          [
            _c("div", { staticClass: "form-row" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email"
                      }
                    ],
                    staticClass: "form-control login-input",
                    attrs: { id: "email", type: "text", placeholder: "Email" },
                    domProps: { value: _vm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "email" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("input", {
              staticClass: "btn btn-primary form-control login-button",
              attrs: {
                type: "submit",
                value: "Resend email",
                disabled: _vm.errors.any()
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm._m(1)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-8 offset-2" }, [
      _c("div", { staticClass: "row medium-font" }, [
        _c("div", { staticClass: "col-3" }, [
          _c("a", { attrs: { href: "#" } })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6 text-center" }, [
          _c("h3", [_c("strong", [_vm._v("Grow your business with mod24")])])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row big-font" }, [
        _c("div", { staticClass: "col text-center" }, [
          _c("p", [
            _c("strong", [
              _vm._v(
                "\n              The link you have used has expired\n            "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row medium-font" }, [
        _c("div", { staticClass: "col text-center" }, [
          _c("p", [
            _c("strong", [
              _vm._v(
                "\n              Enter the email you used to register to request a new link.\n            "
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-8 offset-2" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col text-right" }, [
          _c("a", { staticClass: "thick-font", attrs: { href: "#" } }, [
            _vm._v("Need help?")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("p", { staticClass: "info-text" }, [
            _vm._v("Visit our knowledge base")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22fd6413", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22fd6413","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/VerificationExpired.vue
// module id = null
// module chunks = 